import * as Website from '../../Config/Website.js';
import InterviewFilter from './modules/InterviewFilter.js';


const preinit = () => {

}

const init = () => {
  InterviewFilter();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
